'use client';

import { c as _c } from "react/compiler-runtime";
import { useSessionList } from '@clerk/nextjs';
import { Avatar, AvatarFallback, AvatarImage } from '@extern/ui/avatar';
import { Button } from '@extern/ui/button';
import { Text } from '@extern/ui/text';
import { useRouter, useSearchParams } from 'next/navigation';
import { useAuthEvents } from '@/app/(auth)/_hooks/use-auth-events';
import { useSignInFlowStore } from '@/app/(auth)/sign-in/_hooks/use-sign-in-flow-store';
import { useUtmParams } from '@/hooks/use-utm-params';
import { DEFAULT_LOGGED_PAGE } from '@/infra/constants/routes';
import { getAllowlistedSearchParams } from '@/utils/get-allowlisted-search-params';
import { getNameInitials } from '@/utils/get-name-initials';
export function SignInChooseSessionExperiment() {
  const $ = _c(17);
  const router = useRouter();
  const {
    setActive,
    sessions,
    isLoaded
  } = useSessionList();
  const {
    trackSignInSessionSelected
  } = useAuthEvents();
  useUtmParams();
  const searchParams = useSearchParams();
  if (!isLoaded) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-center font-dm font-normal text-3xl text-black leading-8">Active sessions</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== router || $[2] !== sessions || $[3] !== setActive || $[4] !== trackSignInSessionSelected) {
    let t2;
    if ($[6] !== router || $[7] !== setActive || $[8] !== trackSignInSessionSelected) {
      t2 = session => <div className="flex items-center justify-between gap-4" key={session.id}><Avatar className="bg-transparent" size="40"><AvatarImage src={session?.publicUserData?.imageUrl} /><AvatarFallback size="40" variant="initials">{getNameInitials(`${session?.publicUserData?.firstName} ${session?.publicUserData?.lastName}`)}</AvatarFallback></Avatar><div className="flex flex-1 flex-col gap-1 text-left"><Text body="lg" className="font-medium leading-none">{`${session?.publicUserData?.firstName} ${session?.publicUserData?.lastName}`}</Text><Text body="lg" className="text-role-on-background-subtle">{session?.publicUserData.identifier}</Text></div><Button appearance="filled" color="info" onClick={async () => {
          if (session?.id && setActive) {
            trackSignInSessionSelected("existing_session", {
              method: "google"
            });
            useSignInFlowStore.getState().onChange({
              step: "start"
            });
            await setActive({
              session: session.id,
              redirectUrl: DEFAULT_LOGGED_PAGE
            });
            router.push(DEFAULT_LOGGED_PAGE);
          }
        }}>Access</Button></div>;
      $[6] = router;
      $[7] = setActive;
      $[8] = trackSignInSessionSelected;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    t1 = sessions.map(t2);
    $[1] = router;
    $[2] = sessions;
    $[3] = setActive;
    $[4] = trackSignInSessionSelected;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[10] !== searchParams || $[11] !== sessions.length || $[12] !== trackSignInSessionSelected) {
    t2 = sessions.length === 0 && <div className="flex flex-col gap-4 text-center"><Text body="lg" className="text-role-on-background-subtle">No active sessions</Text><Button appearance="filled" asChild={true} className="w-full" color="info"><a href={`/sign-in?${getAllowlistedSearchParams(searchParams)}`} onClick={() => {
          trackSignInSessionSelected("fallback");
        }}>Sign in using a different account</a></Button></div>;
    $[10] = searchParams;
    $[11] = sessions.length;
    $[12] = trackSignInSessionSelected;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[14] !== t1 || $[15] !== t2) {
    t3 = <div className="flex w-full max-w-full flex-col gap-6 overflow-clip rounded-3xl border border-role-outline-subtle bg-white p-6 sm:w-[358px]">{t0}<div className="flex flex-col gap-4">{t1}{t2}</div></div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  return t3;
}